<template>
  <!-- 福利中心-新人充值管理 -->
  <div class="test-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button type="primary" @click="openDialog(1)"
            >添加充值任务</el-button
          >
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="id" label="ID" align="center"> </el-table-column>
        <el-table-column prop="title" label="标题" align="center">
        </el-table-column>
        <el-table-column prop="satisfaction" label="充值金额" align="center">
        </el-table-column>
        <!-- <el-table-column prop="amount" label="奖励金额" align="center">
        </el-table-column> -->
        <!-- <el-table-column prop="weight" label="权重" align="center">
        </el-table-column> -->
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="{ row }">
            <el-tag type="primary" v-if="row.status === 1">正常</el-tag>
            <el-tag type="info" v-if="row.status === 2">关闭</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template slot-scope="{ row }">
            <el-row class="operation-row">
              <el-button type="primary" size="small" @click="openDialog(2, row)"
                >编辑</el-button
              >
              <!-- <el-button size="small" type="danger" @click="refused(row)"
                >拒绝</el-button
              > -->
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 弹窗 -->
    <!-- 添加/编辑新人充值任务 -->
    <NewUserTaskDialog
      v-model="dialogInfos"
      :visible="dialogVisible"
      :type="dialogType"
      @close="dialogVisible = false"
      @refresh="getData()"
    ></NewUserTaskDialog>
  </div>
</template>

<script>
import {
  mapActions,
  mapMutations,
  mapState
} from 'vuex'
import http, {
  server,
  api,
  delApiData,
  getApiData,
  postApiData,
  patchApiData
} from '@/http'
import NewUserTaskDialog from './components/NewUserTaskDialog'

export default {
  components: {
    NewUserTaskDialog
  },
  data() {
    return {
      dialogVisible: false,//弹窗显示标志
      loading: false, //加载动画
      query: {
        page: 1
      },
      dialogType: 1,//1是添加 2是修改 默认是1
      dialogInfos: undefined,//传给弹窗的数据
      dataList: undefined, //数据列表
      dataMeta: undefined, //底部跳转页面条
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      getApiData('welfare_new_user').then(res => {
        if (res) {
          this.dataList=res
         }
      }).finally(() => {
        this.loading = false
      })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
    openDialog(num, val) {
      //打开添加队伍弹窗
      this.dialogVisible = true
      if (num === 1) {
        this.dialogType = 1
        this.dialogInfos = undefined
      }
      if (num === 2) {
        this.dialogType = 2
        this.dialogInfos = JSON.parse(JSON.stringify(val))
      }
    },
  }
}

</script>
<style lang="less" scoped>
.debris_formula_config-box {
  header {
  }

  .body-box {
    // width: 800px;
  }
}
</style>
